var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"logo-container"},[_c('div',{staticClass:"logo",style:({ backgroundImage: ("url(" + _vm.logo + ")") })}),_c('h3',[_vm._v("热门彩种")])])}
var staticRenderFns = []

export { render, staticRenderFns }